// extracted by mini-css-extract-plugin
export default {"scaleContainer":"ScaleExercise_scaleContainer__LItIh"};